import React from 'react';
import { Box, Typography, useMediaQuery, Link } from '@mui/material';
import locationIcon from '../../../assets/icons/location.png';
import phone from '../../../assets/icons/phone.png';
import theme from '../../../theme';

const ShopLocationInformation = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const contactNumbers = [
    "02-4067233",
    "02-4067234",
    "02-4065567",
    "02-4039110",
    "02-4039319",
    "09-782004472",
    "09-964065567",
    "09-404040577",
    "09-404040677",
    "09-952009123",
  ];
  const viberInviteLink =
    "https://invite.viber.com/?g2=AQAcvOWA6No9dk73hnxYyJsEhJ%2BH%2B7SBiyHY6%2FOl5b2LdRos6%2Frsd7BUpA5ocvFt";
  const viberNumbers = [
    "09-782004472",
    "09-404040677",
    "09-964065567",
  ];
  const toDialNumber = (rawNumber) => rawNumber.replace(/[^\d]/g, "");
  const toViberNumber = (rawNumber) => {
    const digits = toDialNumber(rawNumber);
    if (digits.startsWith("0")) {
      return `95${digits.slice(1)}`;
    }
    return digits;
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: isMobile ? "10px" : "12px",
      }}
    >
      <Box
        sx={{
          width: isMobile ? "92%" : "70%",
          display: "flex",
          justifyContent: "center",
          alignItems: "stretch",
          flexDirection: "column",
          textAlign: "left",
          gap: isMobile ? "14px" : "10px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "flex-start",
            gap: 2,
            justifyContent: "flex-start",
            textAlign: "left",
          }}
        >
          <img src={locationIcon} alt="Location icon" style={{ width: 20, objectFit: 'contain' }} />
          <Typography
            sx={{
              fontSize: isMobile ? "13px" : "16px",
              fontFamily: `'Roboto', sans-serif`,
              color: theme.palette.text.secondary,
              lineHeight: "1.7",
              wordBreak: "break-word",
            }}
          >
            အမှတ် 108 ၊ 25 လမ်း 83x84 ကြား ၊ အောင်မြေသာဇံမြို့နယ် ၊ မန္တလေးမြို့ ။
            <br />
            9:00 AM to 5:00 PM
            <br />
            ဥပုသ်နေ့တိုင်း နေ့တစ်ပိုင်း ပိတ်ပါသည်။ လစဉ် လပြည့်နေ့တိုင်း ဆိုင်ပိတ်ပါသည်။
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "flex-start",
            gap: 2,
            justifyContent: "flex-start",
            textAlign: "left",
          }}
        >
          <img src={phone} alt="Phone icon" style={{ width: 18, objectFit: 'contain' }} />
          <Typography
            sx={{
              fontSize: isMobile ? "13px" : "16px",
              color: "#515151",
              lineHeight: "1.7",
              wordBreak: "break-word",
            }}
          >
            Contact Numbers:{" "}
            {contactNumbers.map((number, index) => (
              <React.Fragment key={number}>
                <Link
                  href={`tel:${toDialNumber(number)}`}
                  sx={{ color: "inherit", textDecoration: "none" }}
                >
                  {number}
                </Link>
                {index < contactNumbers.length - 1 && ", "}
              </React.Fragment>
            ))}
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "flex-start",
            gap: 2,
            justifyContent: "flex-start",
            textAlign: "left",
          }}
        >
          <img src={phone} alt="Viber icon" style={{ width: 18, objectFit: 'contain' }} />
          <Typography
            sx={{
              fontSize: isMobile ? "13px" : "16px",
              color: "#515151",
              lineHeight: "1.7",
              wordBreak: "break-word",
            }}
          >
            Viber:{" "}
            <Link
              href={viberInviteLink}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                textDecoration: "none",
                display: "inline-flex",
                alignItems: "center",
                padding: "4px 10px",
                borderRadius: "999px",
                backgroundColor: "#7360f2",
                color: "#ffffff",
                fontWeight: 600,
                fontSize: isMobile ? "12px" : "13px",
                boxShadow: "0 6px 16px rgba(115, 96, 242, 0.25)",
                "&:hover": {
                  backgroundColor: "#5a48e6",
                },
              }}
            >
              Join our Viber Channel
            </Link>
            {viberNumbers.length > 0 && (
              <>
                {viberNumbers.map((number, index) => (
                  <React.Fragment key={number}>
                    <Link
                      href={`viber://chat?number=${toViberNumber(number)}`}
                      sx={{ color: "inherit", textDecoration: "none" }}
                    >
                      {number}
                    </Link>
                    {index < viberNumbers.length - 1 && ", "}
                  </React.Fragment>
                ))}
              </>
            )}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ShopLocationInformation;
